import type { MisconceptionDefinition } from '../types'

export const GELD_WISSEL: MisconceptionDefinition[] = [
  {
    id: 'geld.wissel-no-conversion',
    label: 'Negeert wisselkoers (1:1)',
    module: 'Geld',
    description:
      'Leerling denkt dat 1 euro = 1 dollar (of pond/yen) en past de wisselkoers niet toe.',
    typicalFamilies: ['GELD-WISSEL', 'GELD-WISSELEN'],
  },
  {
    id: 'geld.wissel-divide-instead',
    label: 'Deelt i.p.v. vermenigvuldigt bij wisselkoers',
    module: 'Geld',
    description:
      'Leerling deelt door de wisselkoers terwijl vermenigvuldigen nodig is (of omgekeerd).',
    typicalFamilies: ['GELD-WISSEL', 'GELD-WISSELEN'],
  },
  {
    id: 'geld.wissel-multiply-instead',
    label: 'Vermenigvuldigt i.p.v. deelt bij wisselkoers',
    module: 'Geld',
    description:
      'Leerling vermenigvuldigt met de wisselkoers terwijl delen nodig is (terugconversie naar euro).',
    typicalFamilies: ['GELD-WISSEL', 'GELD-WISSELEN'],
  },
  {
    id: 'geld.wissel-add-rate',
    label: 'Telt wisselkoers op i.p.v. vermenigvuldigt',
    module: 'Geld',
    description:
      'Leerling telt de wisselkoers op bij het bedrag in plaats van te vermenigvuldigen.',
    typicalFamilies: ['GELD-WISSEL', 'GELD-WISSELEN'],
  },
  {
    id: 'geld.wissel-wrong-divisor',
    label: 'Gebruikt verkeerde grootteorde deler',
    module: 'Geld',
    description:
      'Leerling deelt door verkeerde grootteorde (bijv. 13 i.p.v. 130 yen per euro).',
    typicalFamilies: ['GELD-WISSEL', 'GELD-WISSELEN'],
  },
  {
    id: 'geld.wissel-divide-by-100',
    label: 'Deelt door 100 i.p.v. wisselkoers',
    module: 'Geld',
    description:
      'Leerling deelt automatisch door 100 (percentage-reflex) in plaats van door de wisselkoers.',
    typicalFamilies: ['GELD-WISSEL', 'GELD-WISSELEN'],
  },
  {
    id: 'geld.wissel-rounding-error',
    label: 'Rondt te vroeg of verkeerd af bij wisselkoers',
    module: 'Geld',
    description:
      'Leerling rondt tussenuitkomsten te vroeg af of in de verkeerde richting bij wisselkoers-berekening.',
    typicalFamilies: ['GELD-WISSEL', 'GELD-WISSELEN'],
  },
  {
    id: 'geld.wissel-wrong-rate',
    label: 'Gebruikt verkeerde wisselkoers',
    module: 'Geld',
    description:
      'Leerling gebruikt de verkeerde wisselkoers (bijv. 1,20 i.p.v. 1,10) terwijl de juiste in de vraag staat.',
    typicalFamilies: ['GELD-WISSEL', 'GELD-WISSELEN'],
  },
]
